import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import TopUp from "@/pages/TopUp";
import Team from "@/pages/Team";
import Withdraw from "@/pages/Withdraw";
import Profile from "@/pages/Profile";
import Addresses from "@/pages/Addresses";
import SellerProducts from "@/pages/SellerProducts";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminCategories from "@/pages/admin/Categories";
import AdminOrders from "@/pages/admin/Orders";
import AdminDeposits from "@/pages/admin/Deposits";
import AdminWithdrawals from "@/pages/admin/Withdrawals";
import AdminUsers from "@/pages/admin/Users";
import AdminMasterPanel from "@/pages/admin/MasterPanel";
import SubAdmins from "@/pages/admin/SubAdmins";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center font-mono text-xs uppercase tracking-widest">// LOADING</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="catalog" element={<Catalog />} />
                <Route path="product/:id" element={<ProductDetail />} />
                <Route path="cart" element={<Cart />} />
                <Route path="checkout" element={<Protected><Checkout /></Protected>} />
                <Route path="orders" element={<Protected><Orders /></Protected>} />
                <Route path="orders/:id" element={<Protected><OrderDetail /></Protected>} />
                <Route path="topup" element={<Protected><TopUp /></Protected>} />
                <Route path="withdraw" element={<Protected><Withdraw /></Protected>} />
                <Route path="team" element={<Protected><Team /></Protected>} />
                <Route path="profile" element={<Protected><Profile /></Protected>} />
                <Route path="addresses" element={<Protected><Addresses /></Protected>} />
                <Route path="seller" element={<Protected><Profile /></Protected>} />
                <Route path="seller/products" element={<Protected><SellerProducts /></Protected>} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
              </Route>
              <Route path="admin" element={<Protected><AdminLayout /></Protected>}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="deposits" element={<AdminDeposits />} />
                <Route path="withdrawals" element={<AdminWithdrawals />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="master-panel" element={<AdminMasterPanel />} />
                <Route path="sub-admins" element={<SubAdmins />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;